export enum SamoobslugaActions {
  ZAKTUALIZUJ_TOKEN = '[Samoobsluga] zaktualizowano token',
  POBIERZ_DANE_ZGLOSZENIA = '[Samoobsluga] Pobierz dane zgloszenia',
  ZAKTUALIZUJ_STAN = '[Samoobsluga] zaktualizowano stan',
}
